import { IAgreementDetails } from '@services/backend-server';
import { IMember, models as memberModels } from '@services/members';
import { IProgram } from '@services/communities';

export enum AutomationVariableIdentifierEnum {
  TRIGGER_AGREEMENT = 'TRIGGER_AGREEMENT',
  TRIGGER_BRIEF_LINK = 'TRIGGER_BRIEF_LINK',
  TRIGGER_CONTENT_REVIEW = 'TRIGGER_CONTENT_REVIEW',
  TRIGGER_INVITE = 'TRIGGER_INVITE',
  TRIGGER_MEMBER = 'TRIGGER_MEMBER',
  TRIGGER_MESSAGE = 'TRIGGER_MESSAGE',
  TRIGGER_PFA_ORDER = 'TRIGGER_PFA_ORDER',
  TRIGGER_RESOURCE = 'TRIGGER_RESOURCE',
  TRIGGER_STA_OFFER = 'TRIGGER_STA_OFFER',
  TRIGGER_THREAD = 'TRIGGER_THREAD',
  TRIGGER_PFA_ORDER_REQUEST = 'TRIGGER_PFA_ORDER_REQUEST',
  TRIGGER_TOTAL_CONVERSIONS = 'TRIGGER_TOTAL_CONVERSIONS',
  TRIGGER_TOTAL_SALES = 'TRIGGER_TOTAL_SALES',
  TRIGGER_CONVERSION_TYPE = 'TRIGGER_CONVERSION_TYPE',
  TRIGGER_CONVERSION_ID = 'TRIGGER_CONVERSION_ID',
  TRIGGER_ORDER_VALUE = 'TRIGGER_ORDER_VALUE',
  TRIGGER_BOOST_REWARD_COUNT = 'TRIGGER_BOOST_REWARD_COUNT',
  TRIGGER_CONVERSION_DATE = 'TRIGGER_CONVERSION_DATE',
  // New offer-related variables
  TRIGGER_OFFER_INFO = 'TRIGGER_OFFER_INFO',
  TRIGGER_TIER_INFO = 'TRIGGER_TIER_INFO',
  TRIGGER_REWARD_INFO = 'TRIGGER_REWARD_INFO',
}

export type AutomationVariableIdentifier = typeof AutomationVariableIdentifierEnum[keyof typeof AutomationVariableIdentifierEnum];

export enum AutomationVariableType {
  AGREEMENT = 'AGREEMENT',
  BRIEF_LINK = 'BRIEF_LINK',
  CONTENT_REVIEW = 'CONTENT_REVIEW',
  INVITE = 'INVITE',
  MEMBER = 'MEMBER',
  MESSAGE = 'MESSAGE',
  PFA_ORDER = 'PFA_ORDER',
  RESOURCE = 'RESOURCE',
  STA_OFFER = 'STA_OFFER',
  THREAD = 'THREAD',
  TOTAL_CONVERSIONS = 'TOTAL_CONVERSIONS',
  TOTAL_SALES = 'TOTAL_SALES',
  CONVERSION_TYPE = 'CONVERSION_TYPE',
  CONVERSION_ID = 'CONVERSION_ID',
  ORDER_VALUE = 'ORDER_VALUE',
  BOOST_REWARD_COUNT = 'BOOST_REWARD_COUNT',
  CONVERSION_DATE = 'CONVERSION_DATE',
  // New offer-related types
  OFFER_INFO = 'OFFER_INFO',
  TIER_INFO = 'TIER_INFO',
  REWARD_INFO = 'REWARD_INFO',
}

// Offer-related interfaces
export interface IOfferInfo {
  id: number;
  offerName: string;
  startDate: string;
  endDate?: string;
  memberPromoCode: string;
  memberSharableLink: string;
  payoutId: number;
  payoutValue: string;
  creatorPortalUrl: string;
  activeDates?: string;
  payoutText?: string
}

export interface ITierInfo {
  tierName: string;
  offerId: number,
  payoutValue: string; // in readbale format for email
  creatorPortalUrl: string;
}

export interface IRewardInfo {
  rewardName: string; // in readbale format for email
  offerId: number,
  rewardValue: string;
  creatorPortalUrl: string;
  rewardType?: string;
}

export type AutomationVariableValue =
  | string
  | number
  | boolean
  | Date
  | string[]
  | number[]
  | boolean[]
  | Date[]
  | IOfferInfo
  | ITierInfo
  | IRewardInfo
  | null;

export interface IAutomationVariable {
  id: string;
  type: AutomationVariableType;
  name: string;
}

export interface IAutomationExecutionVariable extends IAutomationVariable {
  value: AutomationVariableValue;
}

export type AutomationVariableEntity = IAgreementDetails | IMember | IProgram | memberModels.MemberOrder | null;
export interface IAutomationInstanceVariable extends IAutomationExecutionVariable {
  entity: AutomationVariableEntity;
}
